import React, { useEffect, useState, useRef } from "react";
import ArrowIcon from './assets/Arrow 2.svg';
import './AddNewPricing.css';
import FadeLoader from "react-spinners/FadeLoader";
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Checkbox from "@mui/material/Checkbox";
import { Table, TableContainer } from "@mui/material";
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Paper from '@mui/material/Paper';
import NoPricingRuleImg from '../../Images/NoRules.png';
import { FiEdit3, FiTrash2 } from "react-icons/fi";
import { set } from "date-fns";
import Typography from '@mui/material/Typography';
import { de } from "date-fns/locale";

const AddNewPricing = ({
    mode,
    pricingPlanData,
    setEditingPricingPlan,
    onBackToPricing,
    setUpdateData,
    editPopup,
    setEditPopup,
    setIsPricingPopupOpen,
    onSaveSuccess,
    setLoader,
    setLoading,

    loading
}) => {
    const [pricingRules, setPricingRules] = useState([]);
    const [isDefault, setIsDefault] = useState(pricingPlanData?.isDefault || "");
    const [location, setLocation] = useState(pricingPlanData?.location || "");
    const [startTime, setStartTime] = useState(pricingPlanData?.startTime || "");
    const [endTime, setEndTime] = useState(pricingPlanData?.endTime || "");
    const [duration, setDuration] = useState('');
    const [price, setPrice] = useState(pricingPlanData?.price || "");
    const [rateUnit, setRateUnit] = useState(pricingPlanData?.rateUnit || "");
    const [selectedDays, setSelectedDays] = useState([]);
    const [allDay, setAllDay] = useState(false);
    const [errors, setErrors] = useState({});
    const [locationSuggestions, setLocationSuggestions] = useState([]);
    const [showLocationSuggestions, setShowLocationSuggestions] = useState(false);
    const [isLocationSelected, setIsLocationSelected] = useState(false);
    const [pricingPlanName, setPlanName] = useState(pricingPlanData?.pricingPlanName || "");
    const [pricingPlanDescription, setPricingPlanDescription] = useState(pricingPlanData?.pricingPlanDescription || "");
    const hostPath = process.env.REACT_APP_API_BASE_URL;
    const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;
    const wrapperRef = useRef(null);
    const weekOrder = [1, 2, 3, 4, 5, 6, 0];
    const navigate = useNavigate();
    const [ispricingRulesPopupOpen, setIspricingRulesPopupOpen] = useState(false);
    const [editingRuleIndex, setEditingRuleIndex] = useState(null);
    const [ruleToDelete, setRuleToDelete] = useState(null);
    const [open, setOpen] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    const [showUnsavedDialog, setShowUnsavedDialog] = useState(false);

    const formatTime = (date) => {
        const hours = (`${date.getHours()}`).padStart(2, '0');
        const minutes = (`${date.getMinutes()}`).padStart(2, '0');
        return `${hours}:${minutes}`;
    };







    // Add this function at component level (near other handlers)
    const checkDuplicatePlanName = async (planName) => {
        if (!planName.trim()) return false;

        try {

            const response = await fetch(`${hostPath}/api/GetAllPricingPlans`, {
                headers: { "x-functions-key": hostHeader }
            });
            const allPlans = await response.json();

            const duplicate = allPlans.find(plan =>
                plan.pricingPlanName.toLowerCase() === planName.toLowerCase() &&
                plan.id !== pricingPlanData?.id  // ✅ Exclude current plan in edit mode
            );

            return !!duplicate;  // returns true if duplicate found

        } catch (error) {
            console.error("Error checking duplicate plan name:", error);
            return false;
        }
    };
    const formatDays = (arr) =>
        weekOrder.filter(d => arr.includes(d)).map(d => dayMap[d]).join(", ");
    const dayMap = {
        0: "Sunday",
        1: "Monday",
        2: "Tuesday",
        3: "Wednesday",
        4: "Thursday",
        5: "Friday",
        6: "Saturday"
    };

    const handleSavePricingRule = () => {
        const rule = {
            days: selectedDays || [],
            timeRange: {
                startTime: startTime,
                endTime: endTime
            },
            price: Number(price),
            rateUnit: rateUnit
        };

        let updatedRules;

        if (editingRuleIndex !== null) {
            // EDIT existing rule
            updatedRules = [...pricingRules];
            updatedRules[editingRuleIndex] = rule;
        } else {
            // ADD new rule
            updatedRules = [...pricingRules, rule];
        }

        // ✅ CHECK FOR COLLISIONS BEFORE SAVING
        const collisions = detectRuleCollisions(updatedRules);

        if (collisions.length > 0) {
            // ✅ Set as ERROR message (like other validations)
            setErrors((prev) => ({
                ...prev,
                ruleCollision: collisions.map(c => c.message).join('\n'),
            }));

            return;
        }

        // ✅ Clear collision error if no collision
        setErrors((prev) => ({
            ...prev,
            ruleCollision: "",
        }));

        // ✅ No collisions - proceed
        setPricingRules(updatedRules);
        setIsDirty(true);

        // Reset popup state
        setEditingRuleIndex(null);
        setIspricingRulesPopupOpen(false);
        setSelectedDays([]);
        setAllDay(false);
        setPrice("");
        setRateUnit("");
    };

    function convertTo24Hour(timeString) {
        let t = timeString.trim().toUpperCase();
        if (!t.endsWith("AM") && !t.endsWith("PM")) {
            return t;
        }
        const isPM = t.endsWith("PM");
        t = t.replace(/AM|PM/, "").trim();

        let [hh, mm = "00"] = t.split(":");
        let hours = parseInt(hh, 10);
        let minutes = parseInt(mm, 10) || 0;

        if (isPM && hours < 12) hours += 12;
        if (!isPM && hours === 12) hours = 0;

        return String(hours).padStart(2, "0") + ":" + String(minutes).padStart(2, "0");
    }

    const days = [
        { id: 0, label: "Sun" },
        { id: 1, label: "Mon" },
        { id: 2, label: "Tue" },
        { id: 3, label: "Wed" },
        { id: 4, label: "Thu" },
        { id: 5, label: "Fri" },
        { id: 6, label: "Sat" }];

    const toggleDay = (dayId) => {
        setSelectedDays(prev => {
            let updatedDays;
            if (prev.includes(dayId)) {
                updatedDays = prev.filter(d => d !== dayId);
            } else {
                updatedDays = [...prev, dayId];
            }
            // Update allDay if all days are selected
            setAllDay(updatedDays.length === days.length);
            return updatedDays;
        });
    };

    const handleAllDayChange = () => {
        if (allDay) {
            setAllDay(false);
            setSelectedDays([]);     // Clear all days
        } else {
            setAllDay(true);
            setSelectedDays(days.map(d => d.id));   // Select all days
        }
    };
    const handlleAddPricingRules = () => {
        setIspricingRulesPopupOpen(true);
        setEditingRuleIndex(null);
        setSelectedDays([]);
        setAllDay(false);
        setPrice("");
        const now = new Date();
        const defaultStartTimeStr = formatTime(now);
        const defaultEndTimeStr = formatTime(new Date(now.getTime() + 60 * 60 * 1000));
        setStartTime(defaultStartTimeStr);
        setEndTime(defaultEndTimeStr);
        setDuration(calculateDuration(defaultStartTimeStr, defaultEndTimeStr));
        setRateUnit("");

    }
    const handleCancelPricingRules = () => {
        setIspricingRulesPopupOpen(false);
        setSelectedDays([]);
        setAllDay(false);
        setPrice("");
        setRateUnit("");
        setEditingRuleIndex(null);
        setErrors((prev) => ({
            ...prev,
            ruleCollision: "",
        }));

    }
    const handleChange = (field, value) => {  //  No longer async
        setIsDirty(true);

        if (field === "pricingPlanName") {
            const regex = /^[A-Za-z\s]*$/;

            // Prevent space as first character
            if (value.length === 1 && value.startsWith(" ")) {
                return;
            }

            setPlanName(value);

            // ✅ Only basic validation (no duplicate check here)
            let errorMsg = "";
            if (!value.trim()) {
                errorMsg = "Pricing Plan Name is required.";
            } else if (!regex.test(value)) {
                errorMsg = "Enter alphabetic characters only";
            }

            setErrors((prev) => ({
                ...prev,
                pricingPlanName: errorMsg,
            }));
        }

        if (field === "pricingPlanDescription") {
            setPricingPlanDescription(value);
            setErrors((prev) => ({
                ...prev,
                pricingPlanDescription:
                    value.length > 150
                        ? "Description cannot exceed 150 characters"
                        : "",
            }));
        }
    };
    // Add this function at component level
    const detectRuleCollisions = (rules) => {
        const collisions = [];

        for (let i = 0; i < rules.length; i++) {
            for (let j = i + 1; j < rules.length; j++) {
                const rule1 = rules[i];
                const rule2 = rules[j];

                // ✅ Check if they share any days
                const sharedDays = rule1.days.filter(day => rule2.days.includes(day));
                if (sharedDays.length === 0) continue;  // No overlap

                // ✅ Convert times to minutes for comparison
                const time1Start = convertTimeToMinutes(rule1.timeRange.startTime);
                const time1End = convertTimeToMinutes(rule1.timeRange.endTime);
                const time2Start = convertTimeToMinutes(rule2.timeRange.startTime);
                const time2End = convertTimeToMinutes(rule2.timeRange.endTime);
                // ✅ Check if time ranges overlap
                const timeOverlap = time1Start < time2End && time2Start < time1End;

                if (timeOverlap) {
                    collisions.push({
                        rule1Index: i,
                        rule2Index: j,
                        sharedDays: sharedDays.map(d => dayMap[d]),
                        message: `Rule ${i + 1} and Rule ${j + 1} overlap on ${sharedDays.map(d => dayMap[d]).join(", ")} 
                    (${formatTimeTo12Hour(rule1.timeRange.startTime)} - ${formatTimeTo12Hour(rule1.timeRange.endTime)} 
                    vs ${formatTimeTo12Hour(rule2.timeRange.startTime)} - ${formatTimeTo12Hour(rule2.timeRange.endTime)})`
                    });
                }
            }
        }

        return collisions;
    };

    // Helper function to convert HH:MM to minutes
    const convertTimeToMinutes = (time) => {
        if (!time) return 0;
        const [hours, minutes] = time.split(':').map(Number);
        return hours * 60 + minutes;
    };
    const handleLocationChange = async (e) => {
        const { value } = e.target;
        setLocation(value);
        setIsLocationSelected(false);
        if (value.trim().length > 2) {
            try {
                const response = await axios.get(
                    `https://atlas.microsoft.com/search/address/json?subscription-key=EN5vcaicwC78zKi3M3980VVB1m7DuuN0vKaDMtYdjBg7daKhx3OTJQQJ99AHAC8vTIngVrqvAAAgAZMPLtXG&api-version=1.0&language=en-US&query=${value}&countrySet=US`
                );
                const results = response.data.results || [];

                // Filter valid US addresses with street info
                const locSuggestions = results?.filter(result => result.address.countryCode === 'US' && result.address.streetNumber).map((result) => result.address);

                setLocationSuggestions(locSuggestions);
                setShowLocationSuggestions(true);
            } catch (error) {
                console.error("Error fetching location suggestions:", error);
            }
        } else {
            setLocationSuggestions([]);
            setShowLocationSuggestions(false);
        }

        setErrors((prev) => ({
            ...prev,
            location: value ? "" : "Location is required.",
        }));
    };

    const handleLocationSelect = (selected) => {
        setLocation(selected.freeformAddress);
        setLocationSuggestions([]);
        setShowLocationSuggestions(false);
        setIsLocationSelected(true);
    };
    const formatTimeTo12Hour = (time24) => {
        if (!time24) return "";

        const [hours, minutes] = time24.split(':').map(Number);
        const period = hours >= 12 ? 'PM' : 'AM';
        const hours12 = hours % 12 || 12; // Convert 0 to 12 for midnight

        return `${hours12}:${minutes.toString().padStart(2, '0')} ${period}`;
    };



    const handleStartTimeChange = (event) => {
        const newStartTime = convertTo24Hour(event.target.value);
        setStartTime(newStartTime);
        updateStartAndEndTime(newStartTime, endTime);
    };

    const handleEndTimeChange = (event) => {
        const newEndTime = convertTo24Hour(event.target.value);
        setEndTime(newEndTime);
        updateStartAndEndTime(startTime, newEndTime);
    };

    const updateStartAndEndTime = (startTime, endTime) => {
        if (!startTime || !endTime) {
            return;
        }
        setDuration(calculateDuration(startTime, endTime));
    };


    const handleSubmit = async () => {
        setLoader(true);
        const newErrors = {};

        // ✅ Validate plan name
        if (!pricingPlanName?.trim()) {
            newErrors.pricingPlanName = "Pricing Plan Name is required.";
        }
        else {
            // ✅ CHECK FOR DUPLICATE PLAN NAME (only on submit)
            const isDuplicate = await checkDuplicatePlanName(pricingPlanName);
            if (isDuplicate) {
                newErrors.pricingPlanName = `Pricing plan "${pricingPlanName}" already exists. Please choose a different name.`;
            }
        }

        // ✅ Must have at least 1 rule
        if (!pricingRules || pricingRules.length === 0) {
            newErrors.pricingRules = "At least one pricing rule is required.";
            alert("Please add at least one pricing rule before saving.");
            setLoader(false);
            setErrors(newErrors);
            return;
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setLoader(false);
            return;
        }

        try {

            // ✅ Build RULES ARRAY (VERY IMPORTANT)
            const rulesPayload = pricingRules.map(rule => ({

                SelectedDays: rule.days,   // matches backend
                TimeRanges: [
                    {
                        StartTime: rule.timeRange.startTime,
                        EndTime: rule.timeRange.endTime,
                    }],
                Price: Number(rule.price), // ensure numeric
                RateUnit: rule.rateUnit,

            }));


            // ✅ FINAL CREATE PAYLOAD
            const payload = {
                PricingPlanName: pricingPlanName.trim(),
                Description: pricingPlanDescription?.trim() || "",
                IsDefault: Boolean(isDefault), // prevents "" bug
                Rules: rulesPayload
            };

            // ✅ UPDATE payload
            const updatePayload = {
                id: pricingPlanData?.id,
                PricingPlanID: pricingPlanData?.pricingPlanID,
                PricingPlanName: pricingPlanName.trim(),
                Description: pricingPlanDescription?.trim() || "",
                IsDefault: Boolean(isDefault),
                CreatedDate: pricingPlanData?.createdDate,
                LastUpdatedDate: new Date().toISOString(),
                Rules: rulesPayload
            };

            const url = mode === "edit"
                ? `${hostPath}/api/UpdatePricingPlan`
                : `${hostPath}/api/AddNewPricingPlan`;

            const method = mode === "edit" ? "PUT" : "POST";

            const requestPayload = mode === "edit" ? updatePayload : payload;
            const response = await fetch(url, {
                method,
                headers: {
                    "x-functions-key": hostHeader,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestPayload),
            });

            if (!response.ok) {
                const errorData = await response.text();
                console.error("❌ API Error:", errorData);
                throw new Error(errorData || `HTTP error! Status: ${response.status}`);
            }

            const responseData = await response.json();
            setIsDirty(false);
            setIsPricingPopupOpen(false);
            setUpdateData(prev => !prev);


        } catch (error) {

            console.error("💥 Error saving pricing plan:", error);
            // alert(`Failed to save pricing plan: ${error.message}`);
        }
        finally {
            setLoader(false);

        }
    };

    useEffect(() => {
        if (mode === "edit" && pricingPlanData) {
            // Set simple fields
            setPlanName(pricingPlanData.pricingPlanName || "");
            setPricingPlanDescription(pricingPlanData.description || "");
            setIsDefault(pricingPlanData.isDefault || false);

            // ✅ Map API rules → component state
            if (pricingPlanData.rules && Array.isArray(pricingPlanData.rules)) {
                const mappedRules = pricingPlanData.rules.map(rule => ({
                    days: rule.selectedDays || [],
                    timeRange: {
                        startTime: rule.timeRanges?.[0]?.startTime || "",
                        endTime: rule.timeRanges?.[0]?.endTime || ""
                    },
                    price: rule.price || 0,
                    rateUnit: rule.rateUnit || "hour"
                }));

                setPricingRules(mappedRules);

                // ✅ Set initial form values from first rule (if exists)
                if (mappedRules.length > 0) {
                    const firstRule = mappedRules[0];
                    setSelectedDays(firstRule.days);
                    setAllDay(firstRule.days.length === 7);
                    setStartTime(firstRule.timeRange.startTime);
                    setEndTime(firstRule.timeRange.endTime);
                    setDuration(
                        calculateDuration(
                            firstRule.timeRange.startTime,
                            firstRule.timeRange.endTime
                        )
                    );
                    setPrice(firstRule.price);
                    setRateUnit(firstRule.rateUnit);
                }
            }
        }


        //   // Set default times
        const now = new Date();
        const defaultStartTimeStr = formatTime(now);
        const defaultEndTimeStr = formatTime(new Date(now.getTime() + 60 * 60 * 1000));
        setStartTime(defaultStartTimeStr);
        setEndTime(defaultEndTimeStr);
        setDuration(calculateDuration(defaultStartTimeStr, defaultEndTimeStr));

    }, [pricingPlanData, mode]);

    const isSaveEnabled = () => {

        if (!isDirty) {
            return false;
        }
        if (
            !pricingPlanName.trim() ||
            !pricingRules.length
        ) {
            return false;
        }

        if (errors.pricingPlanName) {
            return false;
        }
        return true;
    };
    const isSaveRuleEnabled = () => {
        if (

            !startTime ||
            !endTime ||
            !selectedDays.length ||
            !price ||
            !rateUnit
        ) {
            return false;
        }

        return true;
    };

    const isAddRuleEnabled = () => {
        // if(!pricingPlanName.trim() ){
        //   return false;

        // }
        return true;

    }

    // Calculate duration between start and end times
    const calculateDuration = (start, end) => {
        if (start && end) {
            // Parse start time
            const [startHours, startMinutes] = start.split(':').map(Number);
            // Parse end time
            const [endHours, endMinutes] = end.split(':').map(Number);

            // Calculate total minutes
            const startTotalMinutes = startHours * 60 + startMinutes;
            const endTotalMinutes = endHours * 60 + endMinutes;

            let diff = endTotalMinutes - startTotalMinutes;

            if (diff < 0) {
                // If end time is before start time, assume the event spans to next day
                diff += 24 * 60;
            }

            const hours = Math.floor(diff / 60);
            const minutes = diff % 60;
            return `${hours}h ${minutes}min`;
        }
        return '';
    };

    const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setShowLocationSuggestions(false);
        }
    };

    const handleConfirm = (action) => {

        // user clicked CANCEL
        if (action === "cancel") {
            setOpen(false);
            setRuleToDelete(null);
            return;
        }

        // user clicked DELETE
        if (action === "confirm") {

            setPricingRules(prevRules =>
                prevRules.filter((_, index) => index !== ruleToDelete)
            );

            // VERY IMPORTANT -> enables Update Pricing Plan button
            setIsDirty(true);

            // reset dialog
            setOpen(false);
            setRuleToDelete(null);
        }
    };

    const handleRemoveRule = (index) => {
        setRuleToDelete(index);
        setOpen(true);

    }
    const handleEditRule = (index) => {
        const rule = pricingRules[index];
        setSelectedDays(rule.days);
        setStartTime(rule.timeRange?.startTime);
        setEndTime(rule.timeRange?.endTime);
        setDuration(rule.duration);
        setPrice(rule.price);
        setRateUnit(rule.rateUnit);
        setEditingRuleIndex(index);
        setIspricingRulesPopupOpen(true);
    };


    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    const handleBackClick = () => {
        setIsPricingPopupOpen(false);
        if (isDirty) {
            setShowUnsavedDialog(true);
            return;
        }
    };



    const handleCancelButton = () => {


        if (mode === "edit" && pricingPlanData) {
            // ✅ EDIT MODE: Revert to original data
            setPlanName(pricingPlanData.pricingPlanName || "");
            setPricingPlanDescription(pricingPlanData.description || "");
            setIsDefault(pricingPlanData.isDefault || false);

            // ✅ Restore original rules (remove newly added ones)
            if (pricingPlanData.rules && Array.isArray(pricingPlanData.rules)) {
                const originalRules = pricingPlanData.rules.map(rule => ({
                    days: rule.selectedDays || [],
                    timeRange: {
                        startTime: rule.timeRanges?.[0]?.startTime || "",
                        endTime: rule.timeRanges?.[0]?.endTime || ""
                    },
                    price: rule.price || 0,
                    rateUnit: rule.rateUnit || "hour"
                }));

                setPricingRules(originalRules);
            }

            setIsDirty(false); // Mark as clean

        } else {
            // ✅ CREATE MODE: Clear everything
            setPlanName("");
            setPricingPlanDescription("");
            setIsDefault(false);
            setPricingRules([]);
            setSelectedDays([]);
            setAllDay(false);
            setPrice("");
            setRateUnit("");
            setDuration("");
            setIsDirty(false);
        }

        // Clear any errors
        setErrors({});
    };

    return (
        <div className="pricing-create-wrapper">
            <div className="pricing-create-content">
                {/* ================= BACK LINK ================= */}

                <div
                    className="pricing-back"
                    onClick={() => {
                        if (isDirty) {
                            setShowUnsavedDialog(true);
                        } else {
                            setIsPricingPopupOpen(false);
                            setUpdateData(prev => !prev);
                        }
                    }}
                >
                    &lt; Back to Pricing
                </div>

                {ispricingRulesPopupOpen &&
                    <div className="popup-overlay">
                        <div className="rule-popup-content">

                            <div className="createnewpricing-container">
                                <p className="pricing-title">Add Pricing Rule</p>

                                <Divider
                                    sx={{
                                        margin: '20px 0px 0px !important'
                                    }}
                                />

                                {/* ✅ Display collision error like other errors */}
                                {errors.ruleCollision && (
                                    <p className="error-message" style={{ whiteSpace: 'pre-line' }}>
                                        {errors.ruleCollision}
                                    </p>
                                )}

                                <div className="pricing-input-container">
                                    <label className="pricing-label">Days<span className="mandatorymark">*</span></label>
                                    <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap' }}>
                                        {days.map(day => (
                                            <button
                                                key={day.id}
                                                type="button"
                                                onClick={() => toggleDay(Number(day.id))}
                                                style={{
                                                    padding: '13px 14px',
                                                    borderRadius: '5px',
                                                    border: selectedDays.includes(day.id) ? 'none' : '1px solid #3C3C3C',
                                                    backgroundColor: selectedDays.includes(day.id) ? '#0A66C2' : '#FFF',
                                                    color: selectedDays.includes(day.id) ? '#fff' : '#000',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                {day.label}
                                            </button>
                                        ))}
                                    </div>
                                </div>

                                <div className="all-days-container">
                                    <input type="checkbox" id="allDay" className="all-days-checkbox" checked={allDay} onChange={handleAllDayChange} />
                                    <label htmlFor="allDay">All Days</label>
                                </div>
                                <div className="pricing-custom-recurrence-icon-wrapper" style={{ marginRight: '10px' }}>
                                    <label htmlFor="time" className="pricing-label" style={{ textAlign: 'left' }}>Time Range<span className="mandatorymark">*</span></label>
                                </div>
                                <div className="pricing-custom-time-group">
                                    <div className="pricing-custom-input-container">
                                        <input
                                            type="time"
                                            className="pricing-custom-input"
                                            value={startTime || ''}
                                            onChange={handleStartTimeChange}
                                            placeholder="Start time"
                                        />
                                    </div>
                                    <div className="pricing-custom-arrow-container">
                                        <img
                                            src={ArrowIcon}
                                            alt="Arrow Icon"
                                            className="pricing-custom-arrow-icon"
                                        />
                                    </div>
                                    <div className="pricing-custom-input-container">
                                        <input
                                            type="time"
                                            className="pricing-custom-input"
                                            value={endTime || ''}
                                            onChange={handleEndTimeChange}
                                            placeholder="End time"
                                        />
                                    </div>
                                    <span className="custom-duration-text"
                                        style={{
                                            marginLeft: '2px',
                                            marginRight: '2px',
                                            fontSize: '12px',
                                        }}
                                    >
                                        {duration}
                                    </span>
                                </div>

                                <div className="price-section">
                                    <label className="pricing-label">Price<span className="mandatorymark">*</span></label>
                                    <div className="price-input-group">
                                        <div className="price-input-wrapper">
                                            <span className="currency-symbol">$</span>
                                            <input type="number" className="price-input" placeholder="Price" min="0" value={price} onChange={(e) => setPrice(e.target.value)} />
                                        </div>
                                        <div className="radio-group">
                                            {/* <label className="radio-option">
                                <input type="radio" name="rateUnit" value="min" checked={rateUnit === "min"}
                                    onChange={(e) => setRateUnit(e.target.value)}/>Per min
                            </label> */}
                                            <label className="rule-radio-option">
                                                <input type="radio" name="rateUnit" value="hour" checked={rateUnit === "hour"}
                                                    onChange={(e) => setRateUnit(e.target.value)}
                                                    style={{ width: '24px', height: '24px' }}/>Per hour
                                            </label>
                                            <label className="rule-radio-option">
                                                <input type="radio" name="rateUnit" value="day" checked={rateUnit === "day"}
                                                    onChange={(e) => setRateUnit(e.target.value)} 
                                                    style={{ width: '24px', height: '24px' }}/>Per day
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div className="pricing-buttons">
                                    <button className="rule-cancel-btn" onClick={handleCancelPricingRules}>
                                        Cancel
                                    </button>
                                    <button
                                        className={isSaveRuleEnabled() ? "add-pricing-btn" : "cancel-pricing-btn"}
                                        onClick={handleSavePricingRule} disabled={!isSaveRuleEnabled()}
                                        style={{ cursor: isSaveRuleEnabled() ? "pointer" : "not-allowed", color: isSaveRuleEnabled() ? "#fff" : "#000000", }}
                                    >
                                        {editingRuleIndex !== null ? "Update Rule" : "Create Rule"}
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                }

                {/* ================= HEADER ================= */}
                <div className="pricing-header">
                    <div>
                        <h2 className="pricing-main-title">
                            {mode === "edit" ? "Edit Pricing Plan" : "Create Pricing Plan"}
                        </h2>

                        <p className="pricing-subtitle">
                            Define Pricing rules for Robotaxi parking based on time and days.
                        </p>
                    </div>

                    <div className="pricing-header-actions">
                        <Button
                            variant="outlined"
                            onClick={handleCancelButton}
                            sx={{
                                textTransform: "none",
                                borderRadius: "5px",
                                color: '#121212',
                                borderColor: '#ddd',
                                backgroundColor:'#E0E0E0',
                                fontSize: '16px',
                                fontWeight: '500',
                                '&:hover': {
                                    borderColor: '#999',
                                    background: '#f5f5f5'
                                }
                            }}
                        >
                            Cancel
                        </Button>

                        <Button
                            variant="contained"
                            onClick={handleSubmit}
                            disabled={!isSaveEnabled()}
                            sx={{
                                textTransform: "none",
                                borderRadius: "5px",
                                background: '#0A66C2',
                                '&:hover': {
                                    background: '#1565c0'
                                }
                            }}
                        >
                            {mode === "edit" ? "Update Pricing Plan" : "Save Pricing Plan"}
                        </Button>
                    </div>
                </div>



                <Divider
                    sx={{
                         margin: '20px 0 !important'
                    }}
                />


                {/* ================= PLAN DETAILS ================= */}
                <div className="pricing-section-title">PLAN DETAILS</div>

                <div className="pricing-form-row">
                    <div className="pricing-form-col-5">
                        <label className="pricing-form-label">
                            Plan Name <span className="required-star">*</span>
                        </label>
                        <TextField
                            fullWidth
                            placeholder="E.g city flexible pricing"
                            size="small"
                            value={pricingPlanName}
                            onChange={(e) => handleChange("pricingPlanName", e.target.value)}

                            error={!!errors.pricingPlanName}
                            helperText={errors.pricingPlanName}
                            sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '5px',
                                        backgroundColor: "#fff !important",
                                        border: '1px solid #969696'
                                    },
                                    '& .MuiOutlinedInput-input': {
                                        color: '#000 !important',
                                        fontFamily: 'Inter, sans-serif',
                                        fontSize: '16px',
                                        fontStyle: 'normal',
                                        fontWeight: 400,
                                        lineHeight: 'normal',
                                    },
                                    '& .MuiOutlinedInput-input::placeholder': {
                                        color: '#A7A7A7',
                                        fontFamily: 'Inter, sans-serif',
                                        fontSize: '16px',
                                        fontStyle: 'normal',
                                        fontWeight: 400,
                                        lineHeight: 'normal',
                                        opacity: 1
                                    }
                                }}
                        />
                    </div>

                    <div className="pricing-form-col-7">
                        <label className="pricing-form-label">
                            Plan Description
                        </label>
                        <TextField
                            fullWidth
                            placeholder="Short description of the pricing plan"
                            size="small"
                            value={pricingPlanDescription}
                            onChange={(e) => handleChange("pricingPlanDescription", e.target.value)}
                            sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '5px',
                                        backgroundColor: "#fff !important",
                                        border: '1px solid #969696'
                                    },
                                    '& .MuiOutlinedInput-input': {
                                        color: '#000 !important',
                                        fontFamily: 'Inter, sans-serif',
                                        fontSize: '16px',
                                        fontStyle: 'normal',
                                        fontWeight: 400,
                                        lineHeight: 'normal',
                                    },
                                    '& .MuiOutlinedInput-input::placeholder': {
                                        color: '#A7A7A7',
                                        fontFamily: 'Inter, sans-serif',
                                        fontSize: '16px',
                                        fontStyle: 'normal',
                                        fontWeight: 400,
                                        lineHeight: 'normal',
                                        opacity: 1
                                    }
                                }}
                        />
                    </div>
                </div>

                {/* <div className="default-plan-checkbox">
                    <Checkbox
                        checked={isDefault}
                       // onChange={(e) => setIsDefault(e.target.checked)}
                        onChange={(e) => {
            setIsDefault(e.target.checked);
            setIsDirty(true);  // 🔥 ADD THIS LINE
        }}
                        sx={{ padding: '0 8px 0 0' }}
                    />
                    <span>Make this the default pricing plan</span>
                </div> */}

                <div className="default-plan-checkbox">
                    <Checkbox
                        checked={isDefault}
                        onChange={(e) => {
                            const newValue = e.target.checked;
                            setIsDefault(newValue);

                            // 🔥 Check if value changed from original
                            if (mode === "edit" && pricingPlanData) {
                                // In edit mode, compare with original value
                                if (newValue !== pricingPlanData.isDefault) {
                                    setIsDirty(true);
                                } else {
                                    // Value reverted to original - check if other fields are dirty
                                    const nameChanged = pricingPlanName !== (pricingPlanData.pricingPlanName || "");
                                    const descChanged = pricingPlanDescription !== (pricingPlanData.description || "");

                                    // Compare rules
                                    const originalRules = pricingPlanData.rules?.map(rule => ({
                                        days: rule.selectedDays || [],
                                        timeRange: {
                                            startTime: rule.timeRanges?.[0]?.startTime || "",
                                            endTime: rule.timeRanges?.[0]?.endTime || ""
                                        },
                                        price: rule.price || 0,
                                        rateUnit: rule.rateUnit || "hour"
                                    })) || [];

                                    const rulesChanged = JSON.stringify(pricingRules) !== JSON.stringify(originalRules);

                                    // Only keep dirty if other fields changed
                                    setIsDirty(nameChanged || descChanged || rulesChanged);
                                }
                            } else {
                                // In create mode, any change is dirty
                                setIsDirty(true);
                            }
                        }}
                        sx={{ padding: '0 8px 0 0' }}
                    />
                    <span>Make this the default pricing plan</span>
                </div>

                {/* ================= PRICING RULES ================= */}
                <div className="pricing-section-title">
                    PRICING RULES
                </div>

                {/* ================= PRICING RULES TABLE ================= */}
                {pricingRules.length === 0 ? (
                    /* ================= EMPTY STATE ================= */
                    <div
                        style={{
                            padding: '19px 16px',
                            textAlign: 'center',
                            marginTop: '26px'
                        }}
                    >
                        <img
                            src={NoPricingRuleImg}
                            alt="No pricing rules"
                            style={{ width: '194px',height: '194px', marginBottom: '28px', opacity: 0.7 }}
                        />

                        <div style={{ fontSize: '16px', fontWeight:'600' }}>
                            No pricing rules have been added yet!
                        </div>
                    </div>
                ) : (
                    /* ================= TABLE ================= */
                    <div className="pricing-table-container" style={{ marginTop: '16px',marginBottom:'20px' }}>
                        <TableContainer
                            component={Paper}
                            sx={{
                                borderRadius: '8px',
                                border: '1px solid #e0e0e0',
                                boxShadow: 'none'
                            }}
                        >
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Rule</TableCell>
                                        <TableCell>Days</TableCell>
                                        <TableCell>Time Range</TableCell>
                                        <TableCell>Price</TableCell>
                                        <TableCell>Actions</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {pricingRules?.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell>Rule {index + 1}</TableCell>
                                            <TableCell>{formatDays(row.days)}</TableCell>
                                            <TableCell>
                                                {formatTimeTo12Hour(row.timeRange?.startTime)} - {formatTimeTo12Hour(row.timeRange?.endTime)}
                                            </TableCell>


                                            <TableCell>${row.price}/{row.rateUnit}</TableCell>
                                            <TableCell>
                                                <FiEdit3 title="Edit" aria-label="Edit" role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && handleEditRule(index)}
                                                    style={{
                                                        width: "38px",
                                                        height: "25px",
                                                        padding: "2px 2px",
                                                        cursor: "pointer",
                                                        justifyContent: "center",
                                                        marginRight: "5px"
                                                    }}
                                                    onClick={() => handleEditRule(index)}
                                                />
                                                <FiTrash2 title="Delete" aria-label="Delete" role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && handleRemoveRule(index)}
                                                    style={{
                                                        width: "38px",
                                                        height: "25px",
                                                        padding: "2px 2px",
                                                        cursor: row.isDefault ? "not-allowed" : "pointer",
                                                        justifyContent: "center",
                                                        marginRight: "5px",
                                                        color: "red",
                                                        opacity: row.isDefault ? 0.5 : 1
                                                    }}
                                                    onClick={() => handleRemoveRule(index)}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                )}
                <Dialog
                    classes={{ paper: 'custom-paper-class-delete' }}
                    aria-labelledby="customized-dialog-title"
                    dividers
                    open={open}
                    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                    <DialogTitle
                        id="customized-dialog-title"
                        sx={{ textAlign: 'start', color: "#000", fontSize: "24px", fontWeight: "700", padding: "5px 24px" }}
                    >
                        Are you Sure You Want to Delete This Rule?
                    </DialogTitle>
                    <DialogContent sx={{ border: "none", padding: "5px 22px", color: "#000" }}>
                        <Typography gutterBottom>
                            Once deleted, this action is irreversible. Please confirm.
                        </Typography>
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: 'right' }}>
                        <Button className='custom-button-cancel' onClick={() => handleConfirm('cancel')}>Cancel</Button>
                        <Button className='custom-button-delete' onClick={() => handleConfirm('confirm')}>Delete</Button>
                    </DialogActions>
                </Dialog>


                <Dialog
                    classes={{ paper: 'custom-paper-class-delete' }}
                    aria-labelledby="customized-dialog-title"
                    dividers
                    open={showUnsavedDialog}
                    sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >

                    <DialogTitle
                        id="customized-dialog-title"
                        sx={{
                            textAlign: 'start',
                            color: "#000",
                            fontSize: "24px",
                            fontWeight: "700",
                            padding: "5px 24px"
                        }}
                    >
                        Unsaved Changes
                    </DialogTitle>

                    <DialogContent
                        sx={{ border: "none", padding: "5px 22px", color: "#000" }}
                    >
                        <Typography gutterBottom>
                            You have unsaved changes.
                            <br />
                            If you leave now, your changes will be lost.
                        </Typography>
                    </DialogContent>

                    <DialogActions sx={{ justifyContent: 'right' }}>

                        {/* LEAVE */}
                        <Button
                            className="custom-button-cancel"
                            onClick={() => {
                                setShowUnsavedDialog(false);
                                setIsPricingPopupOpen(true);
                            }}
                        >
                            Leave
                        </Button>

                        {/* STAY */}
                        <Button
                            className="custom-button-delete"
                            onClick={() => setShowUnsavedDialog(false)}
                        >
                            Stay
                        </Button>

                    </DialogActions>

                </Dialog>



                <div>
                    <Button
                        variant="contained"
                        onClick={handlleAddPricingRules}
                        disabled={!isAddRuleEnabled()}
                        sx={{ textTransform: 'none', borderRadius: '5px', fontWeight: '500', fontSize: '16px', backgroundColor:'#0A66C2'}}
                    >
                        + Add Pricing Rule
                    </Button>
                </div>



            </div>
        </div>
    );
}
export default AddNewPricing;